import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FileUploadDialog } from '../../../commons/components';
import { csvErrorsReportBuilder } from '../../../../helpers/CsvErrorsReportBuilder';
import { usePartialPaymentsBulkUpdate } from '../../infrastructure/store';

const PartialPaymentsBulkUpdateModal = ({ open, handleClose }) => {
  const { country } = useSelector(state => state.config);
  const {
    uploadFile,
    resetDataAndErrors,
    isLoading,
    hasErrors,
    serverError,
    isSuccess,
    errorLines,
  } = usePartialPaymentsBulkUpdate();

  const TITLE = 'Ingreso masivo de Pagos Parciales';
  const DESCRIPTION =
    'Arrastra o selecciona el archivo que deseas cargar. (Formato permitido: CSV, máx. 10 Mb)';

  const CSV_TEMPLATE = {
    sourceType: 'orderinvoice',
    sourceId: 212428,
    amount: 1000,
    paymentDate: '2021-01-02',
    comment: '-',
  };

  if (!open || (isSuccess && !hasErrors)) {
    return null;
  }

  const onClose = () => {
    handleClose();
    resetDataAndErrors();
  };

  return (
    <FileUploadDialog
      open={open}
      handleCloseDialog={onClose}
      handleLoad={uploadFile}
      saving={isLoading}
      errorsCsv={csvErrorsReportBuilder(errorLines)}
      serverError={serverError}
      title={TITLE}
      description={DESCRIPTION}
      csvTemplate={CSV_TEMPLATE[country]}
      actionText="Subir archivo"
      resetDataAndErrors={resetDataAndErrors}
    />
  );
};

PartialPaymentsBulkUpdateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default PartialPaymentsBulkUpdateModal;
